const DEFAULT_FILENAME_DATE_OPTIONS = {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
};

const UTF8_BOM = "\uFEFF";

export const EXPORT_METADATA_COLUMNS = [
  { key: "audit_last_modified", header: "Audit Last Modified" },
  { key: "audit_modified_by", header: "Audit Modified By" },
  { key: "audit_version", header: "Audit Version" },
  { key: "exported_at", header: "Exported At" },
  { key: "export_org", header: "Export Org" },
  { key: "export_tab", header: "Export Tab" },
];

export function normalizeCsvValue(value) {
  if (value === null || value === undefined) {
    return "";
  }

  if (Array.isArray(value)) {
    return value.map(normalizeCsvValue).filter(Boolean).join("; ");
  }

  if (value instanceof Date) {
    return value.toISOString();
  }

  if (typeof value === "boolean") {
    return value ? "true" : "false";
  }

  if (typeof value === "object") {
    return JSON.stringify(value);
  }

  return String(value);
}

export function escapeCsvValue(value) {
  const normalizedValue = normalizeCsvValue(value);

  if (/[,"\r\n]/.test(normalizedValue)) {
    return `"${normalizedValue.replace(/"/g, '""')}"`;
  }

  return normalizedValue;
}

export function buildCsv(columns, rows) {
  const header = columns.map((column) => escapeCsvValue(column.header)).join(",");
  const body = rows.map((row) =>
    columns.map((column) => escapeCsvValue(row[column.key])).join(",")
  );

  return [header, ...body].join("\r\n");
}

export function appendExportMetadata(rows, { org, tabLabel, exportedAt }) {
  return rows.map((row) => ({
    ...row,
    audit_last_modified: row.audit_last_modified || row.dateModified || row.modifiedDate || row.updatedDate || "",
    audit_modified_by: row.audit_modified_by || row.modifiedBy || row.modifiedByName || "",
    audit_version: row.audit_version || row.version || "",
    exported_at: exportedAt,
    export_org: org || "DEV",
    export_tab: tabLabel,
  }));
}

export function buildExportFilename({ org, tabLabel, date = new Date() }) {
  const safeOrg = sanitizeFilenamePart(org || "DEV");
  const safeTab = sanitizeFilenamePart(tabLabel || "catalog");
  const formattedDate = date
    .toLocaleDateString("en-CA", DEFAULT_FILENAME_DATE_OPTIONS)
    .replace(/\//g, "-");

  return `${safeOrg}_${safeTab}_${formattedDate}.csv`;
}

export function downloadCsv({ filename, csv }) {
  // Prefix UTF-8 BOM so spreadsheet apps preserve accented and multilingual characters.
  const blob = new Blob([UTF8_BOM, csv], { type: "text/csv;charset=utf-8;" });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");

  link.href = url;
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}

function sanitizeFilenamePart(value) {
  return normalizeCsvValue(value)
    .trim()
    .normalize("NFC")
    .replace(/[\\/:*?"<>|]+/g, "-")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-+|-+$/g, "");
}